import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Ebook_bg from "../../images/ebook/ebook-back.png"


function Banner(props) {
    return (
        <div className="services_banner ebook-banner" style={{backgroundImage: `url(${Ebook_bg})`}}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Ebook">
                                <h1>Your library on the go Download Free Resources Now!</h1>
                                <p>Update yourself with the latest trends, insights and information by downloading free Resources from our Library!</p>
                            </div>
                            <div className="banner_content_txt listing_flex ">
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;